export const APP_ROUTES = {
  HOME: "home",
  UPCOMING_MOVIES: "upcomingmovies",
  MOVIE: "movie",
};
